export default __webpack_public_path__ + "static/media/email_pink.e70e70a7.png";